export default __webpack_public_path__ + "static/media/settings.3b6c7fcf.svg";